export function Spinner({style, size = "48px", color = "primary-600", thickness = "4px", className}) {
    return (<div className={`loader ${className}`} style={{width: size, height: size, ...style}}>
        <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" style={{"stroke": `var(--${color})`}} fill="none" r="20" cx="50" cy="50" strokeWidth={thickness} strokeMiterlimit="10"/>
        </svg>
       
    </div>)

    // return (
    //     <div className={className}>
    //         <div style={{height: size, width: size, borderColor: `var(--${color})`, borderWidth: `${thickness}!important`}} className="prog-spinner"></div>
    //     </div>
    // )
}